import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { callOperation, actions as asyncActions } from "async-ops";
import MdaeDataGrid, { IMdaeDataGridProps } from "../data-grid";
import { GET_SYSTEM_MESSAGES } from "./services/get-system-messages";
import { isEqual } from "lodash";
import { MasterDetail } from "devextreme-react/data-grid";
import {
  TOGGLE_NOTIFICATION_AND_SYSTEM_MSG_GRID_SEARCH_PANEL,
  TOGGLE_SYSTEM_MESSAGES_LIST_ACTION_POPOVER,
  SET_SYSTEM_MESSAGES,
  SET_ADD_SYSTEM_MESSAGE_POPUP_DATA,
  TOGGLE_ADD_SYSTEM_MESSAGE_POPUP,
  TOGGLE_SYSTEM_NOTICE_POPUP,
} from "./reducers/notification-and-system-messages-reducer";
import { MARK_SYSTEM_MESSAGE_AS_READ } from "./services/mark-system-message-as-read";
import { getDataGridActionEllipsisComponent } from "../data-grid-action-ellipsis";
import MdaeActionPopover from "../menu-action-popover/component";
import { convertDateFormat } from "../../../utils/dateUtils";
import AddSystemMessagePopup, {
  SYSTEM_MESSAGES_POPUP_MODES,
  toggeleSystemNoticePopup,
} from "./add-system-message-popup";
import NotifyPopup from "../notify-popup";
import { TOGGLE_CONFIRMATION_POPUP } from "../../mdae-common-reducer";
import { delteSystemMessageConfirmMessage } from "./constants";
import { UPDATE_SYSTEM_MESSAGE } from "./services/update-system-message";
import dateFns from "date-fns";
import { popupMessageLeadTimeMinutes } from "../../../app/ApplicationEventHandler";

export const toggleNotificaionAndSystemMsgGridSearchPanel = (
  dispatch,
  isVisible
) => {
  dispatch({
    type: TOGGLE_NOTIFICATION_AND_SYSTEM_MSG_GRID_SEARCH_PANEL,
    data: {
      isNotificationAndSystemMessagesGridSearchPanelVisible: isVisible,
    },
  });
};
export const toggleAddSystemMessagePopupVisible = (
  dispatch,
  isVisible,
  title,
  mode,
  data?
) => {
  dispatch({
    type: TOGGLE_ADD_SYSTEM_MESSAGE_POPUP,
    data: {
      isAddAddSystemMessagesPopupVisible: isVisible,
      addAddSystemMessagesPopupTitle: title,
      addAddSystemMessagesPopupMode: mode,
    },
  });
  if (data) {
    dispatch({
      type: SET_ADD_SYSTEM_MESSAGE_POPUP_DATA,
      data: { systemMessagePopupFormData: { ...data } },
    });
  }
};
const markMessageAsRead = (messageId) => {
  callOperation(MARK_SYSTEM_MESSAGE_AS_READ, messageId);
};
interface ISystemMessagesComponent {
  visible: boolean;
  permissions: {
    hasCreateAccess: boolean;
    hasUpdateAccess: boolean;
    hasDeleteAccess: boolean;
  };
}
const processSystemMessages = (dispatch, messages) => {
  for (var i = 0; i < messages.length; i++) {
    var message = messages[i];
    message.publishDate = dateFns.format(message.publishDate + "Z");
    message.unpublishDate = dateFns.format(message.unpublishDate + "Z");
  }

  // Pop messages
  for (var i = 0; i < messages.length; i++) {
    var message = messages[i];
    if (
      message.read === false &&
      message.showAsPopup === true &&
      message.status !== "Draft" &&
      message.status !== "Deleted"
    ) {
      var now = new Date();
      var targetDate = new Date(message.publishDate);
      targetDate.setMinutes(
        targetDate.getMinutes() - popupMessageLeadTimeMinutes
      );

      var endDate = new Date(message.unpublishDate);

      if (now > targetDate) {
        message.read = true;
        markMessageAsRead(message.messageId);
        if (now < endDate) {
          toggeleSystemNoticePopup(dispatch, true, message);
        }
      }
    }
  }
};
export const getSystemMessage = (dispatch) => {
  dispatch(asyncActions.asyncOperationStart(GET_SYSTEM_MESSAGES, {}));
};
const SystemMessageDetailTemplate = ({ data }) => {
  const messages = data;
  messages.longText = messages?.longText.replace(/(\r\n|\n|\r)/g, "<br />");
  messages.emailText = messages?.emailText.replace(/(\r\n|\n|\r)/g, "<br />");

  return (
    <div>
      <div className="message-publish-date">
        Start Date:{" "}
        {convertDateFormat(messages.publishDate, "MMMM Do YYYY,h:mm:ss a")}
      </div>
      <div className="message-publish-date">
        End Date:{" "}
        {convertDateFormat(messages.unpublishDate, "MMMM Do YYYY,h:mm:ss a")}
      </div>
      <div className="message-category">Category: {messages.category}</div>
      <div className="message-showaspopup">
        Show as popup: {messages.showAsPopup ? "true" : "false"}
      </div>
      <br />
      <div className="message-details">
        {messages.emailText ? messages.emailText : messages.popupText}
      </div>
    </div>
  );
};
const SystemMessagesComponent: React.FC<ISystemMessagesComponent> = (props) => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const [currentSelectedRowData, setCurrentSelectedRowData] = useState(null);
  const systemMessageList: any[] = useSelector(
    (state) => state["notificationAndSystemMessagesReducer"].systemMessageList,
    isEqual
  );
  const _authorized: boolean = useSelector(
    (state) => state["notificationAndSystemMessagesReducer"].isAuthorized,
    isEqual
  );
  const refreshSystemMessagesGrid = useSelector(
    (state: any) =>
      state.notificationAndSystemMessagesReducer.refreshSystemMessagesGrid,
    isEqual
  );
  const isSystemMessagesDataGridPopoverVisible = useSelector(
    (state: any) =>
      state.notificationAndSystemMessagesReducer
        .isSystemMessagesDataGridPopoverVisible,
    isEqual
  );
  useEffect(() => {
    asyncAction.asyncOperationStart(GET_SYSTEM_MESSAGES);
  }, []);
  useEffect(() => {
    if (systemMessageList?.length > 0) {
      processSystemMessages(dispatch, systemMessageList);
    }
  }, [systemMessageList]);
  useEffect(() => {
    if (refreshSystemMessagesGrid)
      asyncAction.asyncOperationStart(GET_SYSTEM_MESSAGES);
  }, [refreshSystemMessagesGrid]);

  const toggleSystemMessagesListActionPopover = (isVisible, target) => {
    dispatch({
      type: TOGGLE_SYSTEM_MESSAGES_LIST_ACTION_POPOVER,
      data: {
        systemMessagesDataGridPopoverTarget: target,
        isSystemMessagesDataGridPopoverVisible: isVisible,
      },
    });
  };
  const deleteCurrentSelectedSystemMessage = () => {
    asyncAction.asyncOperationStart(UPDATE_SYSTEM_MESSAGE, {
      ...currentSelectedRowData,
      status: "Deleted",
    });
  };
  const hideConfirmationPopup = () => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        visible: false,
      },
    });
  };
  const showConfirmationPopup = (message) => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        onConfirm: () => {
          deleteCurrentSelectedSystemMessage();
          hideConfirmationPopup();
        },
        mdaePopupTitle: "Warning",
        visible: true,
        confirmShown: true,
        declineShown: true,
        width: 380,
        height: 200,
        contentHtml: message,
        onDecline: hideConfirmationPopup,
      },
    });
  };
  const toggleConfirmationPopupVisible = (isVisible, message) => {
    if (isVisible) {
      showConfirmationPopup(message);
    } else {
      hideConfirmationPopup();
    }
  };
  const isSystemMessagePopupFormReadOnly = (displayStatus) => {
    displayStatus = displayStatus?.toLowerCase();
    if (
      displayStatus &&
      (displayStatus === "closed" || displayStatus === "deleted")
    )
      return true;
    else if (
      displayStatus &&
      (displayStatus === "active" || displayStatus === "pending") &&
      props.permissions?.hasUpdateAccess
    )
      return false;

    return true;
  };
  const messagesListActionPopoverMenuList = [
    {
      text: (() =>
        isSystemMessagePopupFormReadOnly(currentSelectedRowData?.displayStatus)
          ? "View"
          : "Edit")(),
      icon: () => {
        const iconClassName = isSystemMessagePopupFormReadOnly(
          currentSelectedRowData?.displayStatus
        )
          ? "preview-action-icon"
          : "edit-action-icon";

        return <div style={{ height: "14px" }} className={iconClassName}></div>;
      },
      onClick: () => {
        if (
          isSystemMessagePopupFormReadOnly(
            currentSelectedRowData?.displayStatus
          )
        )
          toggleAddSystemMessagePopupVisible(
            dispatch,
            true,
            "View Message",
            SYSTEM_MESSAGES_POPUP_MODES.VIEW,
            currentSelectedRowData
          );
        else
          toggleAddSystemMessagePopupVisible(
            dispatch,
            true,
            "Edit Message",
            SYSTEM_MESSAGES_POPUP_MODES.EDIT,
            currentSelectedRowData
          );

        toggleSystemMessagesListActionPopover(false, null);
      },
    },
    {
      text: "Delete",
      visible: props.permissions?.hasDeleteAccess,
      icon: () => {
        return (
          <div
            style={{ height: "16px" }}
            className={"delete-action-icon"}
          ></div>
        );
      },
      onClick: () => {
        if (currentSelectedRowData.displayStatus?.toLowerCase() === "active")
          toggleConfirmationPopupVisible(
            true,
            delteSystemMessageConfirmMessage
          );
        else deleteCurrentSelectedSystemMessage();

        toggleSystemMessagesListActionPopover(false, null);
      },
    },
  ];
  const isNotificationAndSystemMessagesGridSearchPanelVisible = useSelector(
    (state) =>
      state["notificationAndSystemMessagesReducer"]
        .isNotificationAndSystemMessagesGridSearchPanelVisible,
    isEqual
  );

  const notificationsDataGridProps = useMemo(
    () =>
      getRefTaskListDataGridOptions(
        isNotificationAndSystemMessagesGridSearchPanelVisible,
        _authorized,
        setCurrentSelectedRowData,
        toggleSystemMessagesListActionPopover,
        isSystemMessagesDataGridPopoverVisible
      ),
    [isNotificationAndSystemMessagesGridSearchPanelVisible, systemMessageList]
  );
  return (
    <div
      className="system-messages-component"
      style={{ display: props.visible ? "block" : "none" }}
    >
      <MdaeActionPopover
        mdaePopoverConfig={{
          id: "pnlMessagesListActionPopover",
          mdaeDataUpdaterConfig: [
            {
              actionType: TOGGLE_SYSTEM_MESSAGES_LIST_ACTION_POPOVER,
              reducerName: "notificationAndSystemMessagesReducer",
              widgetOptionBindings: {
                target: "systemMessagesDataGridPopoverTarget",
                visible: "isSystemMessagesDataGridPopoverVisible",
              },
            },
          ],
        }}
        menuItemList={messagesListActionPopoverMenuList}
      ></MdaeActionPopover>
      <AddSystemMessagePopup
        toggleAddSystemMessagesPopupVisible={toggleAddSystemMessagePopupVisible}
      />
      <NotifyPopup
        id={"pnlNoticePopup"}
        actionType={TOGGLE_SYSTEM_NOTICE_POPUP}
        widgetConfigPropertyName={"noticePopupConfig"}
        reducerName={"notificationAndSystemMessagesReducer"}
      ></NotifyPopup>
      <MdaeDataGrid {...notificationsDataGridProps}>
        <MasterDetail render={SystemMessageDetailTemplate} />
      </MdaeDataGrid>
    </div>
  );
};

const getRefTaskListDataGridOptions = (
  isNotificationAndSystemMessagesGridSearchPanelVisible,
  _authorized,
  setCurrentSelectedRowData,
  toggleActionPopover,
  isSystemMessagesDataGridPopoverVisible
) => {
  const sampleDataGridOption: IMdaeDataGridProps = {
    id: "pnlRefTaskList",
    width: "100%",
    height: (window.innerHeight * 2) / 3,
    searchPanel: {
      visible: isNotificationAndSystemMessagesGridSearchPanelVisible,
    },
    selection: {
      mode: "single",
    },
    sorting: { mode: "none" },
    onRowClick: function(e) {
      if (!isSystemMessagesDataGridPopoverVisible) {
        const row = e.key;
        if (e.component.isRowExpanded(row)) {
          e.component.collapseRow(row);
          e.component.clearSelection();
        }
      }
    },
    onSelectionChanged: (e) => {
      if (!isSystemMessagesDataGridPopoverVisible) {
        setTimeout(function() {
          const row = e.currentSelectedRowKeys[0];
          const deselectedRow = e.currentDeselectedRowKeys[0];
          if (row) {
            if (e.component.isRowExpanded(deselectedRow)) {
              e.component.collapseRow(deselectedRow);
            }
            e.component.expandRow(row);
          }
        }, 100);
      }
    },
    mdaeColumns: [
      {
        fixed: true,
        alignment: "center",
        visible: _authorized,
        cellRender: (e) => {
          return getDataGridActionEllipsisComponent(e, {
            showActionPopover: toggleActionPopover,
            entityName: "system-messages",
            entityId: e.data.messageId,
            currentRowData: e.data,
            type: 'withoutDispatch',
            currentRowDataUpdater: setCurrentSelectedRowData,
          });
        },
        width: 50,
      },
      {
        dataField: "popupText",
        caption: "Title",
        width: _authorized ? 400 : 230,
        cellRender: function(cellData) {
          var textClass =
            cellData.data.read === true ? "read-message" : "unread-message";
          return <div className={textClass}>{cellData.data.popupText}</div>;
        },
      },
      {
        dataField: "displayStatus",
        caption: "Status",
        width: 80,
        visible: _authorized,
      },
      {
        dataField: "category",
        width: 140,
        visible: _authorized,
      },
      {
        dataField: "publishDate",
        caption: "Start Date",
        visible: _authorized,
        width: 140,
        dataType: "datetime",
      },
      {
        dataField: "unpublishDate",
        caption: "End Date",
        width: 140,
        visible: _authorized,
        dataType: "datetime",
      },
      {
        dataField: "createdBy",
        caption: "Created By",
        width: 140,
        visible: _authorized,
      },
      {
        dataField: "createDate",
        caption: "Create Date",
        width: 110,
        visible: _authorized,
        dataType: "date",
      },
      {
        dataField: "updatedBy",
        caption: "Updated By",
        width: 140,
        visible: _authorized,
      },
      {
        dataField: "updateDate",
        caption: _authorized ? "Update Date" : "Date Posted",
        width: 110,
        dataType: "date",
      },
      {
        dataField: "showAsPopup",
        caption: "Popup",
        width: 90,
        visible: _authorized,
        dataType: "boolean",
      },
      {
        dataField: "clientNames",
        caption: "Applies To",
        visible: _authorized,
        width: 200,
      },
    ],
    paging: {
      enabled: true,
    },
    pager: {
      displayMode: "compact",
      showInfo: true,
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: GET_SYSTEM_MESSAGES,
        isAsyncComplete: true,
        widgetOptionBindings: {
          dataSource: "messages",
        },
      },
      {
        actionType: SET_SYSTEM_MESSAGES,
        reducerName: "notificationAndSystemMessagesReducer",
        widgetOptionBindings: {
          dataSource: "systemMessageList",
        },
      },
    ],
  };
  return sampleDataGridOption;
};

export default SystemMessagesComponent;
